import { data } from '../../svg/ViewDay/data';
import { makeIcon } from '../makeIcon';

export const ViewDay = makeIcon(data, 'viewDay', 'ViewDay');

export default ViewDay;
